"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');
var _reactrouterdom = require('react-router-dom');



var _store = require('web/store');









const pagesDeepMap = (fn) => (ps) => ps.map(p => ({
  ...fn(p),
  ...(p.subroutes && { subroutes: p.subroutes.map(fn) }),
}))

const withPageRouting = (baseRoute) => (p) => ({
  ...p,
  fullRoute: `/${baseRoute}/${p.route}`,
  gotoRoute: () => _store.history.push(`/${baseRoute}/${p.route}`),
  subroutes: _optionalChain([p, 'access', _ => _.subroutes, 'optionalAccess', _2 => _2.map, 'call', _3 => _3(withPageRouting(`${baseRoute}/${p.route}`))]),
})

const markActive = (pathname) => (p) =>
  _reactrouterdom.matchPath.call(void 0, pathname, { path: p.fullRoute }) ? { ...p, isActive: true } : p

// One account links straight to it; several list each by its default org.
const makeAccountPage = (accounts, memberOrgs) => {
  if (accounts.length === 0) return null
  const [only] = accounts
  if (accounts.length === 1 && only) {
    return { label: 'Account', route: `account/${only.DefaultOrgKey}`, icon: 'org' }
  }
  return {
    label: 'Account',
    route: 'account',
    icon: 'org',
    subroutes: accounts.map(a => ({
      label: _nullishCoalesce(_optionalChain([memberOrgs, 'access', _4 => _4.find, 'call', _5 => _5(r => r.OrgKey === a.DefaultOrgKey), 'optionalAccess', _6 => _6.OrgName]), () => ( 'Account')),
      route: a.DefaultOrgKey,
    })),
  }
}

 const useMenu = ({ memberOrgs, managedAccounts, pathname }) => _react.useMemo.call(void 0, 
  () => {
    const accountPage = makeAccountPage(managedAccounts, memberOrgs)
    const cfg = [
      { label: 'Profile', route: 'profile', icon: 'profile' },
      { label: 'Security', route: 'security', icon: 'login' },
      ...(accountPage ? [accountPage] : []),
      {
        label: 'Organizations',
        route: 'orgs',
        icon: 'org',
        subroutes: memberOrgs
          .map(r => ({
            label: r.OrgName,
            route: r.OrgKey,
            hasWarning: r.IsAdmin && r.PendingUsersCount > 0,
            warningCount: r.IsAdmin ? r.PendingUsersCount : 0,
          })),
      },
      { label: 'Notifications', route: 'notifications', icon: 'notifications' },
    ]

    const fullPagesCfg = cfg.map(withPageRouting('settings'))
    return pagesDeepMap(markActive(pathname))(fullPagesCfg)
  },
  [memberOrgs, managedAccounts, pathname],
); exports.useMenu = useMenu
